import type { ReactNode } from "react";

interface PageHeaderProps {
  readonly title: string;
  readonly description?: ReactNode;
  /** Buttons on the right (they move under the title on a phone). */
  readonly actions?: ReactNode;
}

/** The title row of a page, as in the shadcn-admin template. */
export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-3">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">{title}</h1>
        {description !== undefined && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions !== undefined && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
